import React, { useEffect, useState } from "react";
import HallandaleModel from "../../models/hallandale";
import { DataTable } from "../../components";
import { PatientInterface } from "../../interfaces";

const ViewHallandale = () => {
  const [hallandaleEvents, seHallandaleEvents] = useState<PatientInterface[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 15 });
  const [isLoading, setIsLoading] = useState(false);

  const fetchEvents = async (pageIndex: number, pageSize: number) => {
    try {
      setIsLoading(true);
      const skip = pageIndex * pageSize;

      const resp = await HallandaleModel.fetchAll<any>({
        $skip: skip,
        $limit: pageSize,
        $sort: { createdAt: -1 },
      });

      return {
        rows: resp.data,
        totalCount: resp.total,
      };
    } catch (error: any) {
      throw new Error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents(pagination.pageIndex, pagination.pageSize).then((res) => {
      seHallandaleEvents(res.rows);
      setTotalCount(res.totalCount);
    });
  }, [pagination]);

  return <DataTable 
    columns={HallandaleModel.getColumns()} 
    data={hallandaleEvents}  
    pagination={pagination}
    onPaginationChange={setPagination}
    totalRowCount={totalCount}
    loading={isLoading}
  />;
};

export default ViewHallandale;
